// Phase A.2.b BLOCKER 3 · Safe display-name resolver for Contact rows.
//
// Never renders "blank" when a Contact record is missing name fields
// (CC1 imports occasionally have `preferred_name` populated but
// `first_name` empty, or the entire name field trio empty).
//
// Priority:
//   1. preferred_name
//   2. first_name + " " + last_name
//   3. display_name (legacy field on some Contact records)
//   4. primary_email  ← final fallback, never used as a person's real name
//   5. "(no name)" sentinel
//
// Email is the FINAL fallback only — never a normal person's "name".

export function displayName(contact) {
  if (!contact) return "(no name)";
  const preferred = (contact.preferred_name || "").trim();
  if (preferred) return preferred;
  const first = (contact.first_name || "").trim();
  const last = (contact.last_name || "").trim();
  const full = `${first} ${last}`.trim();
  if (full) return full;
  const legacy = (contact.display_name || "").trim();
  if (legacy) return legacy;
  const email = (contact.primary_email || "").trim();
  if (email) return email;
  return "(no name)";
}
